const createActionName = name => `app/tables/${name}`;

export default createActionName;